import { render, staticRenderFns } from "./DesignPortfolioSummary.vue?vue&type=template&id=72278300&"
import script from "./DesignPortfolioSummary.vue?vue&type=script&lang=js&"
export * from "./DesignPortfolioSummary.vue?vue&type=script&lang=js&"
import style0 from "./DesignPortfolioSummary.vue?vue&type=style&index=0&id=72278300&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports